import { COLORS } from '../constants/theme';
import { formatDate } from '../../../../ReusableComponents/functions';

export const drawInfoBoxes = (engine, { selectedCustomer, shippingDetails, orderDateStr }) => {
    const doc = engine.getDoc();
    const boxY = engine.getCursor().getY();
    const boxHeight = 154;
    const boxWidth = 172;
    const boxGap = 12;

    const box1X = 36;
    const box2X = box1X + boxWidth + boxGap; // 220
    const box3X = box2X + boxWidth + boxGap; // 404

    const pad1X = box1X + 8; // 44
    const pad2X = box2X + 8; // 228
    const pad3X = box3X + 8; // 412

    // Background color & border color for the 3 boxes
    doc.setFillColor(...COLORS.BG_BOX);
    doc.setDrawColor(...COLORS.LINE_BORDER);
    doc.setLineWidth(0.75);

    doc.roundedRect(box1X, boxY, boxWidth, boxHeight, 4, 4, 'FD');
    doc.roundedRect(box2X, boxY, boxWidth, boxHeight, 4, 4, 'FD');
    doc.roundedRect(box3X, boxY, boxWidth, boxHeight, 4, 4, 'FD');

    // Box header titles
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(...COLORS.TEXT_MAIN);
    doc.text("ORDER INFORMATION", box1X + (boxWidth / 2), boxY + 16, { align: 'center' });
    doc.text("DATES & TERMS", box2X + (boxWidth / 2), boxY + 16, { align: 'center' });
    doc.text("ADDRESSES", box3X + (boxWidth / 2), boxY + 16, { align: 'center' });

    // Helper to draw bold label & normal value
    const drawField = (label, value, x, labelY, valueY) => {
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(9.5);
        doc.setTextColor(...COLORS.TEXT_MAIN);
        doc.text(label, x, labelY);

        doc.setFont('Helvetica', 'normal');
        doc.setFontSize(9);
        doc.setTextColor(...COLORS.TEXT_MAIN);
        if (value) {
            doc.text(String(value), x, valueY);
        }
    };

    // Box 1: ORDER INFORMATION
    const buyerName = `${selectedCustomer?.firstname || ""} ${selectedCustomer?.lastname || ""}`.trim();
    const customerEmail = selectedCustomer?.email_1 || selectedCustomer?.email_2 || "";

    drawField("STORE NAME", selectedCustomer?.StoreName || "", pad1X, boxY + 35, boxY + 46);
    drawField("BUYER NAME", buyerName, pad1X, boxY + 58, boxY + 69);
    drawField("CUSTOMER EMAIL", customerEmail, pad1X, boxY + 82, boxY + 93);
    drawField("CUSTOMER ID", selectedCustomer?.customerid || "", pad1X, boxY + 106, boxY + 117);
    drawField("PHONE NUMBER", selectedCustomer?.cell_1 || "", pad1X, boxY + 130, boxY + 141);

    // Box 2: DATES & TERMS
    drawField("ORDER DATE", formatDate(orderDateStr || new Date()) || "", pad2X, boxY + 35, boxY + 46);
    drawField("START DATE", formatDate(shippingDetails?.startDate) || "", pad2X, boxY + 58, boxY + 69);
    drawField("CANCEL DATE", formatDate(shippingDetails?.cancelDate) || "", pad2X, boxY + 82, boxY + 93);
    drawField("PAYMENT TERM", shippingDetails?.paymentTerm || "Factor Net 45", pad2X, boxY + 106, boxY + 117);

    // Box 3: ADDRESSES
    // 1. SHIPPING ADDRESS
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(9.5);
    doc.setTextColor(...COLORS.TEXT_MAIN);
    doc.text("SHIPPING ADDRESS", pad3X, boxY + 35);

    const sAdd = shippingDetails?.shippingAddress || {};
    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS.TEXT_MAIN);

    let shipLineY = boxY + 46;
    const storeLine = sAdd.storeName || selectedCustomer?.StoreName || "";
    if (storeLine) {
        doc.text(storeLine, pad3X, shipLineY);
        shipLineY += 11;
    }

    const addr1Str = `${sAdd.address1 || ""}${sAdd.address2 ? ", " + sAdd.address2 : ""}`.trim();
    const cityStateZip = [sAdd.city, sAdd.state, sAdd.postcode].filter(Boolean).join(", ");

    if (addr1Str) {
        doc.text(addr1Str, pad3X, shipLineY);
        shipLineY += 11;
    }
    if (cityStateZip) {
        doc.text(cityStateZip, pad3X, shipLineY);
        shipLineY += 11;
    }
    doc.text(sAdd.country || "USA", pad3X, shipLineY);

    // 2. BILLING ADDRESS
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(9.5);
    doc.setTextColor(...COLORS.TEXT_MAIN);
    doc.text("BILLING ADDRESS", pad3X, boxY + 92);

    const bAdd = shippingDetails?.billingAddress || {};
    const isSameAddress = (!bAdd.address1 && !bAdd.city) ||
        (bAdd.address1 === sAdd.address1 && bAdd.city === sAdd.city);

    if (isSameAddress) {
        doc.setFont('Helvetica', 'normal');
        doc.setFontSize(9);
        doc.setTextColor(...COLORS.TEXT_LIGHT);
        doc.text("Same as shipping", pad3X, boxY + 102);
    } else {
        doc.setFont('Helvetica', 'normal');
        doc.setFontSize(9);
        doc.setTextColor(...COLORS.TEXT_MAIN);
        let billLineY = boxY + 102;
        if (bAdd.address1) {
            doc.text(`${bAdd.address1} ${bAdd.address2 || ""}`.trim(), pad3X, billLineY);
            billLineY += 11;
        }
        const bCityStateZip = [bAdd.city, bAdd.state, bAdd.postcode].filter(Boolean).join(", ");
        if (bCityStateZip) {
            doc.text(bCityStateZip, pad3X, billLineY);
        }
    }

    const endY = boxY + boxHeight + 10;

    // Separator line after boxes
    doc.setDrawColor(...COLORS.LINE_DARK);
    doc.setLineWidth(1);
    doc.line(36, endY, 576, endY);

    return endY;
};
